import React from 'react';
import { cn } from '../../utils/cn';

/**
 * TechBadge - Badge component for displaying technology tags
 *
 * @param {object} props - Component props
 * @param {string} props.tech - Technology name
 * @param {string} [props.className=''] - Additional CSS classes
 * @param {string} [props.variant='default'] - Badge variant: 'default' | 'compact'
 */
const TechBadge = ({ tech, className = '', variant = 'default' }) => {
  const isCompact = variant === 'compact';

  return (
    <span
      className={cn(
        'font-medium rounded-full border transition-colors duration-300',
        'hover:border-[var(--color-accent)]/50 hover:text-[var(--color-accent)]',
        isCompact ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-xs',
        className
      )}
      style={{
        background: 'rgba(0, 212, 170, 0.1)',
        borderColor: 'rgba(0, 212, 170, 0.2)',
        color: 'var(--color-text-muted)'
      }}
    >
      {tech}
    </span>
  );
};

export default TechBadge;
